































































import ApiConfiguration from '@/classes/ApiConfiguration';
import { SweepEmailSourceConfigurationModel, SweepEmailSourceUpdateModel, SweepEmailSourceModel } from '@/services/GeneratedApi';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';

import Vue from 'vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ConfigurationChangeModel, StoreConstants } from '@/types';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SweepEmailSourceConfiguration',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],
  data() {
    return {
      isLoading: false,
      searchQuery: '',
      pageIsLoading: true,
      configurationDataIsLoading: true,
      emailSources: [] as SweepEmailSourceModel[],
      emailSourceConfigurationData: {} as SweepEmailSourceConfigurationModel,
      showUpdateModal: false,
      isSubmitting: false,
      updateEmailSourceModel: 'Add',
      selectedEmailSource: {} as SweepEmailSourceUpdateModel,
      fields: [
        { key: 'actions', label: '', sortable: false, thStyle: { width: '60px' }, tdStyle: { width: '50px' } },
        { key: 'isEnabled', label: 'Status', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'mailboxAddress', label: 'Mailbox Address', sortable: true },
        { key: 'sourceInboxDisplayName', label: 'Inbox Folder', sortable: true },
        { key: 'archiveFolderName', label: 'Archive Folder', sortable: true },
        { key: 'failedFolderName', label: 'Failed Folder', sortable: true },
        { key: 'destinationCabinetName', label: 'Destination Cabinet', sortable: true },
        { key: 'destinationDocumentTypeName', label: 'Destination Document Type', sortable: true },
        { key: 'graphCredentialName', label: 'Graph Credential', sortable: true },
        { key: 'attachmentIndexActionName', label: 'Attachment Index Action', sortable: true },
        { key: 'postProcessActionName', label: 'Post Process Action', sortable: true },
        { key: 'pluginName', label: 'Plugin Name', sortable: true }
      ]
    };
  },
  methods: {
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.BeginChange,
      StoreConstants.ConfigurationChange.Actions.EndChange,
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    async onChangeReasonEntered(this: any, changeReason: string) {
      try {
        await this[StoreConstants.ConfigurationChange.Actions.BeginChange]({
          controllerPath: this.CHANGE_CONTROLLER_PATH,
          configurationChange: {
            description: changeReason
          } as ConfigurationChangeModel
        });
      } catch (error) {
        this.$log(error);
      }
    },
    async onReleaseLock(this: any) {
      await this[StoreConstants.ConfigurationChange.Actions.EndChange](this.CHANGE_CONTROLLER_PATH);
    },
    onAddEmailSource(this: any) {
      this.selectedEmailSource = this.createNewEmailSource();
      this.updateEmailSourceModel = 'Add';
      this.showUpdateModal = true;
    },
    onEditEmailSource(this: any, item: any) {
      const updateEmailSource: SweepEmailSourceUpdateModel = {
        ...item
      };
      this.selectedEmailSource = updateEmailSource;
      this.updateEmailSourceModel = 'Edit';
      this.showUpdateModal = true;
    },

    async deleteEmailSource(this: any, emailSource: any) {
      this.isLoading = true;
      try {
        await ApiConfiguration.api().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationDelete(emailSource.id);
        await this.getEmailSourceConfigurationsAsync();
        SnotifyConfiguration.showSuccess('Email source deleted successfully');
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    onModalCancelled(this: any) {
      this.showUpdateModal = false;
    },
    async onModalSaved(this: any) {
      this.showUpdateModal = false;
      await this.getEmailSourceConfigurationsAsync();
    },
    async onDeleteEmailSource(this: any, item: any) {
      const confirmed = await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete this email source?');
      if (confirmed) {
        await this.deleteEmailSource(item);
      }
    },
    async initialise(this: any) {
      this.pageIsLoading = true;
      await Promise.all([this.getEmailSourceConfigurationsAsync(), this.getEmailSourceConfigurationDataAsync()]);
      this.pageIsLoading = false;
    },
    async getEmailSourceConfigurationsAsync(this: any) {
      try {
        this.isLoading = true;
        this.emailSources = await ApiConfiguration.apiWithErrorPage().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationList();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getEmailSourceConfigurationDataAsync(this: any) {
      try {
        this.emailSourceConfigurationData = await ApiConfiguration.api().sweepEmailSourceConfiguration.sweepEmailSourceConfigurationConfigurationList();
      } catch (error) {
        this.$log(error);
      } finally {
        this.configurationDataIsLoading = false;
      }
    },
    onSearchQueryUpdate(this: any, key: string, value: string) {
      this.searchQuery = value;
    },
    createNewEmailSource(this: any): SweepEmailSourceUpdateModel {
      return {
        mailboxAddress: '',
        sourceInboxId: '',
        sourceInboxDisplayName: '',
        archiveFolderId: '',
        archiveFolderName: '',
        failedFolderId: '',
        failedFolderName: '',
        graphCredentialId: 0,
        description: '',
        destinationCabinetId: '',
        destinationDocumentTypeId: 0,
        attachmentIndexAction: 0,
        isEnabled: true,
        ignoreAttachmentExtensions: '',
        ignoreAttachmentRegex: '',
        signatureFilterEnabled: false,
        signatureMaxFileSizeBytes: 0,
        signatureMaxDimensionPx: 0,
        pluginId: undefined,
        postProcessAction: 0
      } as SweepEmailSourceUpdateModel;
    }
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading
    ]),
    lock(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock];
    },
    bypassLockingOnToolkit(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock];
    },
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    isLockLoading(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading];
    }
  },
  mounted() {
    this.initialise();
  },
  created(this: any) {
    this.CHANGE_CONTROLLER_PATH = 'SweepEmailSourceConfiguration';
  },
  components: {
    MStoreTable: () => import('@/components/shared/Table/MStoreTable.vue'),
    LoadingSpinner: () => import('@/components/shared/LoadingSpinner.vue'),
    SweepEmailSource: () => import('@/components/configuration/sweep/SweepEmailSource.vue'),
    MStoreMakeChangesLock: () => import('@/components/shared/MStoreMakeChangesLock.vue')
  }
});
